import { render, staticRenderFns } from "./productImageBlock.vue?vue&type=template&id=112ff2c2&"
import script from "./productImageBlock.vue?vue&type=script&lang=js&"
export * from "./productImageBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports